export default function favorites(state = [], action) {
    if (action.type === 'TOGGLE_FAVORITE') {
        const id = action.payload;
        if (state.includes(id)) {
            return state.filter(i => i !== id);
        } else {
            return [...state, id];
        }
    }
    return state;
}
